/**
 * Источник кубиков — порт App\Domain\Ludo\DiceRoller.
 *
 * Интерфейсом, а не Math.random() по месту: ход должен быть воспроизводимым
 * в тестах, а бросок — единственное, что мешает движку быть чистой функцией
 * от состояния. На этом же держатся золотые тесты: сценарий из PHP
 * проигрывается здесь тем же списком выпавших значений.
 */
export type DiceRoller = {
  /** Значение одного кубика, 1..6. */
  roll: () => number
}

/** Боевой бросок. */
export function randomRoller(): DiceRoller {
  return { roll: () => Math.floor(Math.random() * 6) + 1 }
}

/**
 * Заранее заданные значения — для тестов и для проигрывания сценария.
 *
 * Кончились — бросает исключение, а не начинает список сначала: молчаливый
 * повтор превратил бы расхождение с PHP в правдоподобную, но чужую партию.
 */
export function scriptedRoller(values: number[]): DiceRoller {
  let at = 0

  return {
    roll: () => {
      if (at >= values.length) throw new Error('scripted dice exhausted')

      return values[at++]
    },
  }
}
